
import { ReactNode } from 'react'
import { Button } from '../Button'
import { Title } from '../Title'
import { CardContainer } from './styles'

type ColorBtnProps = "default" | "outline" | "blue" | "danger" | "warning" | "success";

type classText = "title" | "subtitle" | "subtitle-medium" | "subtitle-small" | "btn-text" | "hiperlink" | "paragraph" | "overline" | "paragraph-small" | "tag";

interface CardProps {
    name?: string;
    title: string;
    labelButton?: string;
    iconButton?: any;
    iconHover?: any;
    children: ReactNode;
    showContent?: boolean;
    hasButton?: boolean;
    hasBorder?: boolean;
    onClick?: any;
    typeBtn?: ColorBtnProps;
    buttonLoad?: boolean;
    typography?: classText;
    buttonWidth?: number;
}

export const Card: React.FC<CardProps> = ({
    name,
    title,
    showContent = true,
    typeBtn = "outline",
    hasButton = false,
    hasBorder = false,
    labelButton = "Ver mais",
    iconButton,
    children,
    onClick,
    iconHover,
    buttonLoad,
    typography = "subtitle-small",
    buttonWidth,
}) => {
    return (
        <CardContainer hasBorder={hasBorder} showContent={showContent}>
            {title || hasButton ?
                <div className="card-header">
                    <Title 
                        text={title} 
                        className={typography}
                        elementHTML="h2" 
                    />
                    {hasButton && <Button
                        type="button"
                        name={name}
                        label={labelButton} 
                        typeBtn={typeBtn} 
                        iconSide="left" 
                        size="small" 
                        icon={iconButton} 
                        iconHover={iconHover} 
                        onClick={onClick}
                        load={buttonLoad}
                        width={buttonWidth}
                    />}
                </div>
             : ""}
            <div className="card-content">
                {children}
            </div>
        </CardContainer>
    )
}